import Vue from 'vue'
import moment from 'moment-timezone'

const state = {
  isFetching: false,
  isFetchingProfessionalCalendarJobs: false,
  professionalCalendar: null,
  professionalCalendarJobs: null
}

const actions = {
  LOAD_PROFESSIONAL_CALENDAR: ({commit}, queryData) => {
    commit('SET_PROFESSIONAL_CALENDAR', null)
    commit('REQUEST_PROFESSIONAL_CALENDAR')
    const url = 'professional/calendars'
    Vue.http.get(url, {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('FINISH_REQUEST_DATA')
        const events = []
        const disallowedDates = []
        const cleaningDates = response.cleaning_dates
        const blockedDates = response.blocked_dates
        const partialBlockedDates = []
        const fullyBookedDates = []

        if (!response.error) {
          // Need to change time format to English in order to push correct event dates
          const currentTimeLocale = moment.locale()
          if (currentTimeLocale !== 'en') {
            moment.locale('en')
          }

          for (let key in blockedDates) {
            const date = blockedDates[key].date
            if (blockedDates[key].blocked_type === 'full') {
              disallowedDates.push(date)
            }
            /*
            // === Don't add partial blocked date into events === //
            else {
              // const eventDate = moment(date).format('ddd MMM DD YYYY')
              // events.push(eventDate)
              partialBlockedDates.push(date)
            }
            */
          }

          for (let key in cleaningDates) {
            const date = cleaningDates[key].date
            const eventDate = moment(date).format('ddd MMM DD YYYY')
            events.push(eventDate)
          }

          // Change time format back to local language
          if (currentTimeLocale !== 'en') {
            moment.locale(currentTimeLocale)
          }
        }

        const professionalCalendar = {
          events,
          disallowedDates,
          blockedDates,
          cleaningDates,
          partialBlockedDates,
          fullyBookedDates
        }
        commit('SET_PROFESSIONAL_CALENDAR', professionalCalendar)
      })
  },
  LOAD_PROFESSIONAL_CALENDAR_JOB_LIST: ({commit}, queryData) => {
    commit('SET_IS_FETCHING_PROFESSIONAL_CALENDAR_JOB_LIST', true)
    commit('REQUEST_PROFESSIONAL_CALENDAR_JOB_LIST')
    const url = 'professional/calendars/jobs'
    Vue.http.get(url, {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_FETCHING_PROFESSIONAL_CALENDAR_JOB_LIST', false)
        if (!response.error) {
          const professionalCalendarJobs = response.calendar_jobs
          commit('SET_PROFESSIONAL_CALENDAR_JOB_LIST', professionalCalendarJobs)
        }
      })
  },
  LOAD_SOLD_OUT_DATES: ({commit}, queryData) => {
    const url = 'professional/calendars/sold-out'
    Vue.http.get(url, {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        const soldOutDates = response.sold_out_dates
        commit('SET_SOLD_OUT_DATES', soldOutDates)
      })
  }
}

const mutations = {
  REQUEST_PROFESSIONAL_CALENDAR: (state) => {
    state.isFetching = true
  },
  REQUEST_PROFESSIONAL_CALENDAR_JOB_LIST: (state) => {
    state.professionalCalendarJobs = null
  },
  FINISH_REQUEST_DATA: (state) => {
    state.isFetching = false
  },
  SET_PROFESSIONAL_CALENDAR: (state, professionalCalendar) => {
    state.professionalCalendar = professionalCalendar
  },
  SET_PROFESSIONAL_CALENDAR_JOB_LIST: (state, professionalCalendarJobs) => {
    state.isFetching = false
    state.professionalCalendarJobs = professionalCalendarJobs
  },
  SET_IS_FETCHING_PROFESSIONAL_CALENDAR_JOB_LIST: (state, status) => {
    state.isFetchingProfessionalCalendarJobs = status
  },
  SET_SOLD_OUT_DATES: (state, soldOutDates) => {
    if (state.professionalCalendar) {
      state.professionalCalendar.fullyBookedDates = soldOutDates
    }
  }
}

const getters = {
  getState: state => {
    return state
  },
  getProfessionalCalendar: state => {
    return state.professionalCalendar
  },
  getProfessionalCalendarJobs: state => {
    return state.professionalCalendarJobs
  },
  getIsFetchingProfessionalCalendarJobs: state => {
    return state.isFetchingProfessionalCalendarJobs
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/professional.calendar.js